import React from "react";
import styled from "styled-components";
import { GamePreviewDTO } from "../../../types/Game";
import { createCssVariableString, DATE_FORMATTER_STR, formatDate, IconAdorner, Typography } from "best-common-react";

const Container = styled.div`
  display: flex;
  align-items: center;
  color: ${createCssVariableString("color-on-surface-warning-text")};
  background-color: ${createCssVariableString("color-surface-warning")};
  padding: 0.5rem 0.25rem;
  border-radius: 0.5rem;
`;

type EventCanceledProps = {
  game: GamePreviewDTO;
};

const EventCanceled: React.FC<EventCanceledProps> = ({ game }) => {
  const [display, setDisplay] = React.useState(false);
  const [message, setMessage] = React.useState("");
  React.useEffect(() => {
    if (game.status && game.status.codedGameState === "C") {
      setDisplay(true);
      setMessage("Cancelled");
    } else if (game.rescheduledFrom) {
      const date = formatDate(game.rescheduledFrom, DATE_FORMATTER_STR);
      setDisplay(true);
      setMessage(`Original date - ${date}`);
    } else if (game.status && game.status.codedGameState === "D") {
      setDisplay(true);
      setMessage("Postponed");
    } else {
      setDisplay(false);
      setMessage("");
    }
  }, [game]);

  return (
    display && (
      <Container>
        <IconAdorner iconName="fa-exclamation-circle" />
        <Typography
          variant="bodySmall"
          className="bcr-ms-2"
          style={{ color: createCssVariableString("color-on-surface-warning-text") }}
        >
          {message}
        </Typography>
      </Container>
    )
  );
};

export default EventCanceled;
